<div class="sticky-footer">
  <ng-content></ng-content>
</div>
